module.exports = __webpack_public_path__ + "fonts/Inter-BoldItalic.8ef77a0.woff2";